<template>
  <v-container fluid class="pa-0">
    <!-- Header Section -->
    <v-row no-gutters>
      <v-col cols="12">
        <v-card flat class="hero-section" color="primary">
          <v-card-text class="text-center pa-8">
            <div class="hero-image mb-6">
              <v-img
                :src="require('@/assets/logoHeader.png')"
                alt="Centro Médico Terrada"
                class="rounded-circle mx-auto"
                max-width="150"
                height="150"
              ></v-img>
            </div>
            <h1 class="display-2 white--text font-weight-bold mb-3">
              Centro Médico Terrada
            </h1>
            <p class="title white--text mb-3">
              Tu salud es nuestra prioridad
            </p>
            <p class="body-1 white--text mb-0">
              Instalaciones modernas y equipamiento de última generación
            </p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Main Content -->
    <v-container class="py-8">
      <!-- Top Row: Info & Services -->
      <v-row class="mb-6">
        <!-- Left Column: About & Contact -->
        <v-col cols="12" md="6">
          <!-- About Us Section -->
          <v-card elevation="2" class="mb-6">
            <v-card-title class="primary white--text">
              <v-icon left color="white">mdi-hospital-building</v-icon>
              Sobre Nosotros
            </v-card-title>
            <v-card-text class="pa-6">
              <p class="body-1 mb-4">
                El Centro Médico Terrada es una institución de salud comprometida con brindar 
                atención médica de calidad a la comunidad de Bahía Blanca y alrededores.
              </p>
              <p class="body-1 mb-4">
                Contamos con un equipo de profesionales altamente capacitados y tecnología 
                de última generación para ofrecerte el mejor cuidado médico.
              </p>
              <p class="body-1">
                Nuestro objetivo es ser tu centro de confianza para todas tus necesidades 
                de salud, brindando un servicio personalizado y humano.
              </p>
            </v-card-text>
          </v-card>

          <!-- Contact Info -->
          <v-card elevation="2">
            <v-card-title class="primary white--text">
              <v-icon left color="white">mdi-phone</v-icon>
              Información de Contacto
            </v-card-title>
            <v-card-text class="pa-6">
              <v-list dense>
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon color="primary">mdi-map-marker</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Dirección</v-list-item-title>
                    <v-list-item-subtitle>{{ contactInfo.ADDRESS }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-icon>
                    <v-icon color="primary">mdi-phone</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Teléfono</v-list-item-title>
                    <v-list-item-subtitle>{{ contactInfo.PHONE.DISPLAY }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-icon>
                    <v-icon color="primary">mdi-whatsapp</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>WhatsApp</v-list-item-title>
                    <v-list-item-subtitle>{{ contactInfo.WHATSAPP.DISPLAY }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-icon>
                    <v-icon color="primary">mdi-email</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Email</v-list-item-title>
                    <v-list-item-subtitle>{{ contactInfo.EMAIL }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>

              <v-divider class="my-4"></v-divider>
              
              <div class="text-center">
                <v-btn 
                  color="primary" 
                  large 
                  :href="contactInfo.PHONE.LINK"
                  class="ma-2"
                >
                  <v-icon left>mdi-phone</v-icon>
                  Llamar Ahora
                </v-btn>
                
                <v-btn 
                  color="green" 
                  large 
                  :href="contactInfo.WHATSAPP.LINK"
                  target="_blank"
                  class="ma-2"
                >
                  <v-icon left>mdi-whatsapp</v-icon>
                  WhatsApp
                </v-btn>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
        
        <!-- Right Column: Services -->
        <v-col cols="12" md="6">
          <v-card elevation="2" class="h-100">
            <v-card-title class="primary white--text">
              <v-icon left color="white">mdi-medical-bag</v-icon>
              Servicios
            </v-card-title>
            <v-card-text class="pa-6">
              <v-list dense>
                <v-list-item v-for="service in services" :key="service.name">
                  <v-list-item-icon>
                    <v-icon color="primary">{{ service.icon }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{ service.name }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Bottom Row: Map & Hours -->
      <v-row>
        <!-- Left Column: Map -->
        <v-col cols="12" md="6">
          <v-card elevation="2" class="h-100">
            <v-card-title class="primary white--text">
              <v-icon left color="white">mdi-map</v-icon>
              Ubicación
            </v-card-title>
            <v-card-text class="pa-0 h-100">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3112.88219970365!2d-62.279192184796464!3d-38.72051347959828!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95edbcbad40e8789%3A0x918a2b13671815db!2sTerrada%20374%2C%20B8000AMH%20Bah%C3%ADa%20Blanca%2C%20Provincia%20de%20Buenos%20Aires!5e0!3m2!1ses!2sar!4v1633638010400!5m2!1ses!2sar"
                width="100%"
                height="400"
                style="border:0;"
                allowfullscreen
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade">
              </iframe>
            </v-card-text>
          </v-card>
        </v-col>
        
        <!-- Right Column: Hours -->
        <v-col cols="12" md="6">
          <v-card elevation="2" class="h-100">
            <v-card-title class="primary white--text">
              <v-icon left color="white">mdi-clock</v-icon>
              Horarios de Atención
            </v-card-title>
            <v-card-text class="pa-6">
              <v-list dense>
                <v-list-item v-for="schedule in schedules" :key="schedule.day">
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium">
                      {{ schedule.day }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ schedule.hours }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>

              <v-alert 
                type="info" 
                dense 
                class="mt-4"
                outlined
              >
                <small>
                  Para consultar disponibilidad con obras sociales específicas, 
                  comuníquese al teléfono o WhatsApp.
                </small>
              </v-alert>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Call to Action -->
      <v-row class="mt-8">
        <v-col cols="12">
          <v-card color="accent" dark class="text-center">
            <v-card-text class="pa-8">
              <h2 class="headline mb-4">¿Necesitas una cita médica?</h2>
              <p class="title mb-6">
                Agenda tu consulta de forma rápida y sencilla
              </p>
              <v-btn 
                large 
                color="white" 
                class="primary--text"
                to="/nuevoturno"
              >
                <v-icon left>mdi-calendar-plus</v-icon>
                Agendar Cita
              </v-btn>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
import { config } from '@/config'

export default {
  name: 'About',
  computed: {
    contactInfo() {
      return config.CONTACT
    }
  },
  data() {
    return {
      services: [
        { name: 'Clínica Médica', icon: 'mdi-stethoscope' },
        { name: 'Cardiología', icon: 'mdi-heart' },
        { name: 'Ginecología y Obstetricia', icon: 'mdi-human-female' },
        { name: 'Neurología y Neurocirugía', icon: 'mdi-brain' },
        { name: 'Cirugía General', icon: 'mdi-hospital-box' },
        { name: 'Cirugía Plástica', icon: 'mdi-face-woman-shimmer' },
        { name: 'Dermatología', icon: 'mdi-face-woman' },
        { name: 'Traumatología', icon: 'mdi-arm-flex' },
        { name: 'Psiquiatría', icon: 'mdi-head-heart' },
        { name: 'Endocrinología y Diabetes', icon: 'mdi-water' },
        { name: 'Neumología', icon: 'mdi-weather-windy' },
        { name: 'Reumatología', icon: 'mdi-human-handsup' },
        { name: 'Nefrología', icon: 'mdi-water-pump' },
        { name: 'Nutrición', icon: 'mdi-food-apple' },
        { name: 'Cirugía Vascular', icon: 'mdi-heart-pulse' }
      ],
      schedules: [
        { day: 'Lunes', hours: '08:00 - 12:00', hours: '14:00 - 18:00' },
        { day: 'Martes', hours: '12:00 - 20:00' },
        { day: 'Miercoles', hours: '13:00 - 17:00' },
        { day: 'Jueves', hours: '12:00 - 20:00' },
        { day: 'Viernes', hours: '08:00 - 16:00' },
      ]
    }
  }
}
</script>
<style scoped>
.hero-section {
  background: linear-gradient(135deg, #8D4E3C 0%, #6D4C41 100%);
  min-height: 400px;
  display: flex;
  align-items: center;
}

.hero-image .v-img {
  border: 4px solid rgba(255, 255, 255, 0.9);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  background-color: white;
}

.v-card {
  border-radius: 12px !important;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.v-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0,0,0,0.15) !important;
}

.v-list-item {
  border-radius: 8px;
  margin-bottom: 4px;
}

.v-list-item:hover {
  background-color: rgba(25, 118, 210, 0.04);
}

.v-btn {
  border-radius: 25px !important;
  text-transform: none !important;
  font-weight: 600;
}

.h-100 {
  height: 100%;
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .hero-section .display-2 {
    font-size: 2rem !important;
  }
  
  .hero-section .title {
    font-size: 1.2rem !important;
  }
}

/* Animation for cards */
.v-card {
  animation: fadeInUp 0.6s ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Custom scrollbar for better UX */
::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: #8D4E3C;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #6D4C41;
}
</style>
